import React, {createRef, RefObject} from 'react'
import {FieldFormElementProps} from "../../render/form-elemnent"

const debug = false
// const debug = "FieldProto_FormElement"

export default class FieldProto_FormElement extends React.Component<FieldFormElementProps> {

    protected ref:RefObject<any> = createRef<any>()

    onClick = () => {
        debug && console.log(debug, 'onClick')
        this.ref.current?.onClick()
    }

    onChange = (value:any) => {
        debug && console.log(debug, 'onChange', value, this.props.form)

        if (this.props.form) {
            this.props.form.onFormComponentValueChange(this.props.field.fieldId, value)
        }

        // on change ya tut ubral poka ... po idee cherez this.form vse idet ....
        // if (this.props.onChange) this.props.onChange(value)
    }

    get value() {
        return this.props.form.getValue(this.props.field.fieldId)
        // return this.props.form ? this.props.form.getValue(this.props.field.fieldId) : this.props.value
    }

    render():JSX.Element | false {
        return <div className="ui5-txt-default ui5-txt-red">{this.props.field.type}.formElement</div>
    }
}
